module.exports = __webpack_public_path__ + "img/Bjornson_Spraaket_i_bondefortellingene.939849d2.jpg";